// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + {"3025":"css/admin-app.6946","8182":"css/app.6946"}[chunkId] + ".css";
};